import { render, staticRenderFns } from "./TableTicker.vue?vue&type=template&id=76afdc38&"
import script from "./TableTicker.vue?vue&type=script&lang=js&"
export * from "./TableTicker.vue?vue&type=script&lang=js&"
import style0 from "./TableTicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports